export default function EmployeesRoute() { return null; }
